interface PromoCarouselLtrProps {
    imageWidth: number
    itemListLength: number
    marginRight: number
    currentPromoIndex?: number
    pushGA4Event?: (action: string, isFeedDisplay: boolean) => void
}

interface PromoCarouselLtrState {
    isCarouselMoving: boolean
    touchStartX: number | null
    isLeftArrowVisible: boolean
    isRightArrowVisible: boolean
}

export class PromoCarouselLtr extends React.Component<PromoCarouselLtrProps, PromoCarouselLtrState> {

    constructor(props: PromoCarouselLtrProps) {
        super(props);
        this.state = {
            touchStartX: null,
            isCarouselMoving: false,
            isLeftArrowVisible: false,
            isRightArrowVisible: false
        };
    }

    private slotWrapperRef: HTMLDivElement | null = null;

    componentDidMount() {
        this.slotWrapperRef.addEventListener('scroll', this.handleScroll);
        this.slotWrapperRef.addEventListener('wheel', this.handleScroll);
        this.handleScroll()
    }

    componentWillUnmount() {
        this.slotWrapperRef.removeEventListener('scroll', this.handleScroll);
        this.slotWrapperRef.removeEventListener('wheel', this.handleScroll);
    }

    private handleScroll = () => {
        const newScrollLeft = this.slotWrapperRef.scrollLeft;
        const isRightArrowVisible = Math.abs(newScrollLeft) + this.slotWrapperRef.clientWidth < this.slotWrapperRef.scrollWidth;
        const isLeftArrowVisible = newScrollLeft > 0;
        this.setState({ isRightArrowVisible, isLeftArrowVisible });
    }

    private onTouchStart = (e) => {
        this.setState({ isCarouselMoving: true, touchStartX: e.touches[0].clientX });
    }

    private onTouchEnd = (e) => {
        const { pushGA4Event, currentPromoIndex, itemListLength } = this.props;
        const { touchStartX } = this.state;

        setTimeout(() => {
            this.setState({ isCarouselMoving: false });
        }, 1000);

        if (touchStartX !== null && e.changedTouches.length > 0) {
            const touchEndX = e.changedTouches[0].clientX;
            const deltaX = touchEndX - touchStartX;
            const shouldPushEventLeft = deltaX < 0 && currentPromoIndex! < itemListLength - 1;
            const shouldPushEventRight = deltaX > 0 && currentPromoIndex! > 0;

            shouldPushEventLeft
                ? pushGA4Event("swipe_left", false)
                : shouldPushEventRight && pushGA4Event("swipe_right", false);
        }
    }

    private handleScrollLeftClicked = () => {
        const { imageWidth, marginRight, pushGA4Event } = this.props;

        const scrollAmount = imageWidth + marginRight;

        this.slotWrapperRef.scrollTo({
            left: this.slotWrapperRef.scrollLeft - scrollAmount,
            behavior: 'smooth'
        });

        pushGA4Event("swipe_left", false);
    };

    private handleScrollRightClicked = () => {
        const { imageWidth, marginRight, pushGA4Event } = this.props;

        const scrollAmount = imageWidth + marginRight;

        this.slotWrapperRef.scrollTo({
            left: this.slotWrapperRef.scrollLeft + scrollAmount,
            behavior: 'smooth'
        });

        pushGA4Event("swipe_right", false);
    };

    public render() {
        const { isRightArrowVisible, isLeftArrowVisible } = this.state;

        return (
            <div className="slotsContent ltr">
                <button
                    aria-label="scroll left"
                    className="scrollLeft arrowBtn"
                    disabled={!isLeftArrowVisible}
                    onClick={this.handleScrollLeftClicked}
                />

                <div className="frame_forList">
                    <div
                        className="slotListWrapper"
                        onTouchEnd={this.onTouchEnd}
                        onTouchStart={this.onTouchStart}
                        ref={(ref) => (this.slotWrapperRef = ref)}
                    >
                        {this.props.children}
                    </div>
                </div>

                <button
                    aria-label="scroll right"
                    className="scrollRight arrowBtn"
                    disabled={!isRightArrowVisible}
                    onClick={this.handleScrollRightClicked}
                />

            </div>
        );
    }
}
